import type { Reducer } from 'redux';

import type { SearchGifsAction } from '../../domains/gifSearch/actions.types';
import { moveToFulfilled, moveToPending, moveToRejected } from '../types';

import type { GifSearches } from './types';

export type GifSearchesAction = SearchGifsAction;

const initialState: GifSearches = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<GifSearches, GifSearchesAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GIF.SEARCH_PENDING':
      return moveToPending(state, [action.payload.id]);
    case 'GIF.SEARCH_REJECTED':
      return moveToRejected(state, [action.payload.id], action.payload.error);
    case 'GIF.SEARCH_FULFILLED':
      return moveToFulfilled(state, action.payload.gifSearches);
    default:
      return state;
  }
};

export default reducer;
